import { useState, useEffect } from 'react';

/**
 * Hook para manejar cuenta regresiva
 * @param {string|Date} targetDate - Fecha objetivo
 * @returns {Object} - { days, hours, minutes, seconds, isExpired }
 */
const useCountdown = (targetDate) => {
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isExpired: false
  });

  useEffect(() => {
    if (!targetDate) return;

    const target = new Date(targetDate).getTime();

    const calculateCountdown = () => {
      const now = new Date().getTime();
      const distance = target - now;

      if (distance <= 0) {
        setCountdown({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          isExpired: true
        });
        return;
      }

      setCountdown({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
        isExpired: false
      });
    };

    // Calcular inmediatamente
    calculateCountdown();

    // Actualizar cada segundo
    const interval = setInterval(calculateCountdown, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return countdown;
};

export default useCountdown;
